<template>
  <div class="login-container">
    <div class="login-header f-b">
      <div style="display: flex; align-items: center;">
        <img src="@/assets/img/logo_login1.png" alt="" style="width: 50px;height: 50px;border-radius: 25px">
        <h2 style="color: white;font-weight: 800">{{ $t('login.title') }}</h2>
      </div>
      <p class="mg-t-24" style="color: white;white-space: pre-line;font-weight: 600;font-size: 32px;">{{ $t('login.welcome_message') }}</p>
      <div style="display: inline-flex; align-items: center;  background-color: rgba(193,216,253); border-radius: 20px; padding: 2px 5px;" class="mg-t-24">
        <img src="@/assets/img/dun.png" alt="" style="width: 30px;height: 30px">
        <span style="font-size: 16px;color: rgb(26,78,211); white-space: nowrap;">{{ $t('login.subtitle_rent_to_own') }}</span>
      </div>
      <div class="feature-row mg-t-24">
        <div class="feature-item">
          <div style="width: 40px; height: 40px; border-radius: 50%; background-color: rgba(193,216,253); display: flex; align-items: center; justify-content: center;">
            <div class="icon-colored icon-rili"></div>
          </div>
          <span style="font-size: 16px;color: white; line-height: 1.6;" class="mg-t-24">{{ $t('login.feature_flexible') }}</span>
        </div>
        <div class="feature-item">
          <div style="width: 40px; height: 40px; border-radius: 50%; background-color: rgba(193,216,253); display: flex; align-items: center; justify-content: center;">
            <div class="icon-colored icon-dunpai"></div>
          </div>
          <span style="font-size: 16px;color: white; line-height: 1.6;" class="mg-t-24">{{ $t('login.feature_trusted') }}</span>
        </div>
        <div class="feature-item">
          <div style="width: 40px; height: 40px; border-radius: 50%; background-color: rgba(193,216,253); display: flex; align-items: center; justify-content: center;">
            <div class="icon-colored icon-dagou"></div>
          </div>
          <span style="font-size: 16px;color: white; line-height: 1.6;" class="mg-t-24">{{ $t('login.feature_yours') }}</span>
        </div>
      </div>
    </div>

    <div class="login-form">
      <!-- 手机号输入 -->
      <div class="input-group">
        <div class="phone-input">
          <input v-model="phoneNumber" type="tel" :placeholder="$t('login.phone_placeholder')" maxlength="13"
            class="input-text phone-number" :class="{ 'error': phoneError }" @input="handlePhoneInput" />
        </div>
        <div v-if="phoneError" class="error-message">{{ phoneError }}</div>
      </div>

      <!-- 验证码输入 -->
      <div class="flex justify-between align-center code-group">
        <div class="code-input-warp">
          <div class="code-input">
            <input v-model="verificationCode" type="text" :placeholder="$t('login.code_placeholder')" maxlength="6"
              class="input-text verification-code" :disabled="!isPhoneValid" @input="handleCodeInput" />
          </div>
        </div>
        <div @click="getVerificationCode" class="get-code-btn" :class="{ 'disabled': !canSendCode }">
          {{ countDownText }}
        </div>
      </div>
      <div v-if="isSend && !verificationCode" class="code-message" :class="{ disabled: !canSubmit }">{{ $t('login.code_message') }}</div>

      <div class="agreement" v-if="agreements.length > 0" @click="toggleAgreement">
        <span class="agreement__radio" :class="{ checked: agreementChecked }"></span>
        <span class="agreement__text">
          {{ agText }}
          <template v-for="(ag, index) in agreements">
            <template v-if="agreements.length > 1 && index === agreements.length - 1">{{ agLastText }}</template>
            <template v-else-if="index > 0">{{ ',' }}</template>
            <span :key="index" @click.stop="goToAgreement(ag)">{{ ag.title }}</span>
          </template>.
        </span>
      </div>
      <!-- 登录按钮 -->
      <div @click="login" class="btn-primary login-btn" :class="{ disabled: !canSubmit }">
        {{ $t('login.login_button') }}
      </div>

      <div class="register-tips">{{ $t('login.registerTips') }}</div>
      <div class="customer-service-link" @click="openCustomerService">
        {{ $t('customerService') }}
      </div>
    </div>
    <div class="bottom-am"></div>
    <van-dialog
      v-model="showCustomerService"
      class="customer-service-dialog"
      :show-confirm-button="false"
    >
      <div class="customer-service">
        <div class="customer-service__close" @click="closeCustomerService">
          <img src="@/assets/img/close.png" alt="">
        </div>
        <div class="customer-service__title">{{ $t('customerService') }}</div>
        <div class="customer-service__content">
          <div class="customer-service__row">
            <span>{{ $t('customerServicePop.whatsapp') }}:</span>
            <strong>{{ customerServicePhone }}</strong>
          </div>
        </div>
        <div class="customer-service__footer">
          <div class="btn-primary customer-service__copy" @click="copyCustomerServicePhone">
            {{ $t('customerServicePop.copy') }}
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { Dialog } from 'vant';
import { getAgreements } from '@/api/common';
import { AGREEMENT_SCENE, LANGUAGE } from '@/common/constants';
import agreement from '@/mixins/agreement';
import i18n from '@/i18n/index';
import { copyText } from '@/utils/clipboard';
import { DEFAULT_REG_CHANNEL } from '@/config';
const LOGIN_DRAFT_KEY = 'rentalLoginDraft';
const LOGIN_CODE_COUNTDOWN_SECONDS = 60;
// const pdata =  require('@/components/AddressPopup/a1.json');
// console.log(pdata)
// let newData = {}
// pdata.map((item,index)=>{
//   if(newData[item.code]){
//     console.log(item)
//   }
//   newData[item.code] = item.region_name || item.province_name || item.city_name
// })
// console.log(JSON.stringify(newData))
export default {
  name: 'LoginPage',
  mixins: [agreement],
  components: {
    'van-dialog': Dialog.Component
  },
  data() {
    return {
      agreements: [],
      phoneNumber: '',           // 手机号
      verificationCode: '',      // 验证码
      countDown: 60,            // 倒计时
      isCounting: false,        // 是否正在倒计时
      timer: null,               // 定时器
      codeExpireAt: 0,
      isSend: false,
      showCustomerService: false,
      customerServicePhone: '+62 822-2777-6752',
      agreementChecked: false
    }
  },
  computed: {
    // 手机号格式校验
    isPhoneValid() {
      return this.$utils.validatePhone(this.phoneNumber);
    },

    // 手机号错误信息
    phoneError() {
      if (!this.phoneNumber) return '';
      if (!this.isPhoneValid) return this.$t('login.invalid_phone');
      return '';
    },

    // 倒计时显示文本
    countDownText() {
      return this.isCounting ?
        this.$t('login.countdown_text', { seconds: this.countDown }) :
        this.$t('login.get_verification_code');
    },

    // 是否可以提交登录
    canSubmit() {
      return this.isPhoneValid && this.verificationCode.length === 6 && this.isAgreementReady;
    },
    canSendCode() {
      return this.isPhoneValid && !this.isCounting && this.isAgreementReady;
    },
    isAgreementReady() {
      return this.agreements.length === 0 || this.agreementChecked;
    },
    postPhoneNumber() {
      if (this.phoneNumber.startsWith('0')) {
        return '62' + this.phoneNumber.substring(1);
      }
      return '62' + this.phoneNumber;
    },
    isEn() {
      return i18n.locale === LANGUAGE.en;
    },
    agText() {
      return this.isEn ? 'By continuing, you agree to the ' : 'Dengan melanjutkan, Anda menyetujui ';
    },
    agLastText() {
      return this.isEn ? ' and ' : ' dan ';
    },
  },
  mounted() {
    // 如果已登录，跳转到首页
    if (this.$store.state.user.session?.accessToken) {
      this.$router.replace('/index')
      return
    }
    this.clearLoginDraft();
    this.queryAgreements();
  },
  activated() {
    if (this.$store.state.user.session?.accessToken) {
      this.$router.replace('/index')
      return
    }
    if (this.codeExpireAt > Date.now() && !this.timer) {
      this.startCountDown(this.codeExpireAt);
    }
  },
  methods: {
    ...mapActions("user", {
      'getCode': 'getCode',
      'reqLogin': 'login'
    }),
    queryAgreements() {
      getAgreements({
        sceneCode: AGREEMENT_SCENE.REGISTER
      }).then(res => {
        if (res.code === 'Success') {
          this.agreements = res.data.agreements || [];
        }
      });
    },
    handlePhoneInput(event) {
      // 只允许输入数字，并限制长度为10位
      let value = event.target.value.replace(/[^\d]/g, '');
      // if (value.length > 11) {
      //   value = value.slice(0, 11);
      // }
      if (value !== this.phoneNumber) {
        this.clearCountDown();
        this.verificationCode = '';
      }
      this.phoneNumber = value;
    },
    handleCodeInput(event) {
      // 只允许输入数字，并限制长度为6位
      let value = event.target.value.replace(/[^\d]/g, '');
      if (value.length > 6) {
        value = value.slice(0, 6);
      }
      this.verificationCode = value;
    },
    toggleAgreement() {
      this.agreementChecked = !this.agreementChecked;
    },
    clearLoginDraft() {
      sessionStorage.removeItem(LOGIN_DRAFT_KEY);
    },
    resetLoginState() {
      this.phoneNumber = '';
      this.verificationCode = '';
      this.agreementChecked = false;
      this.clearCountDown();
      this.clearLoginDraft();
    },
    goToAgreement(agreementInfo) {
      this.$store.commit('user/SET_AGREEMENT_CONTENT', agreementInfo.content);
      this.$router.push({
        name: 'Agreement',
        query: {
          title: agreementInfo.title || '协议'
        }
      });
    },
    ensureAgreementChecked() {
      if (this.isAgreementReady) return true;
      this.$toast(this.$t('login.agreement_required'));
      return false;
    },
    // 获取验证码
    async getVerificationCode() {
      if (!this.isPhoneValid || this.isCounting) return;
      if (!this.ensureAgreementChecked()) return;

      try {
        // 调用获取验证码API
        await this.getCode({
          mobile: this.postPhoneNumber,
          scene: 'login'
        });

        // 隐藏加载状态
        this.$toast(this.$t('login.verification_sent'));

        // 开始倒计时
        this.startCountDown();
      } catch (error) {
        this.$toast(error?.message || this.$t('login.verification_failed'));
      }
    },

    // 开始倒计时
    startCountDown(expireAt = Date.now() + LOGIN_CODE_COUNTDOWN_SECONDS * 1000) {
      this.clearTimer();
      this.codeExpireAt = expireAt;
      this.isCounting = true;
      this.isSend = true;
      this.updateCountDown();

      this.timer = setInterval(() => {
        this.updateCountDown();
      }, 1000);
    },
    updateCountDown() {
      const remain = Math.ceil((Number(this.codeExpireAt || 0) - Date.now()) / 1000);
      if (remain <= 0) {
        this.countDown = 0;
        this.isCounting = false;
        this.codeExpireAt = 0;
        this.clearTimer();
        return;
      }
      this.countDown = remain;
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    clearCountDown() {
      this.clearTimer();
      this.countDown = LOGIN_CODE_COUNTDOWN_SECONDS;
      this.isCounting = false;
      this.isSend = false;
      this.codeExpireAt = 0;
    },

    // 登录
    async login() {
      if (!this.ensureAgreementChecked()) return;
      if (!this.canSubmit) return;

      try {
        // 调用登录API
        await this.reqLogin({
          mobile: this.postPhoneNumber,
          code: this.verificationCode,
          regChannel: this.$store.state.user.channel || DEFAULT_REG_CHANNEL,
        });

        // 登录成功后的处理
        this.$toast(this.$t('login.login_success'));

        // 清空历史记录
        sessionStorage.removeItem('pageHistory')
        this.resetLoginState();

        setTimeout(() => {
          if (this.$route.query.redirect) {
            this.$router.replace(this.$route.query.redirect);
          } else {
            this.$router.push('/index');
          }
        }, 1000);
      } catch (error) {
        this.$toast(error?.message || this.$t('login.login_failed'));
      }
    },
    openCustomerService() {
      this.showCustomerService = true;
    },
    closeCustomerService() {
      this.showCustomerService = false;
    },
    async copyCustomerServicePhone() {
      const success = await copyText(this.customerServicePhone);
      this.$toast(this.$t(success ? 'customerServicePop.copySuccess' : 'customerServicePop.copyFailed'));
    },
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    this.clearTimer();
  }
}
</script>
<style lang="less" scoped>
.login-container {
  position: relative;
  min-height: 100vh;
  overflow-y: auto;
  background: url('../../assets/img/login/login_back.png') center -100px / cover no-repeat;
  display: flex;
  flex-direction: column;
}

.login-header {
  padding: 0 30px;
  margin-top: ~"min(132px, 10vh)";

  h2 {
    font-size: 60px;
    line-height: 69px;
  }

  p {
    font-size: 42px;
    color: var(--text-color-gray);
    line-height: 60px;
  }
}

@media (max-height: 700px) {
  .login-header {
    margin-top: 60px;

    p {
      font-size: 32px;
      line-height: 60px;
    }
  }

  .login-form {
    margin-top: ~"min(200px, 12vh)";
    padding: 30px 24px;
  }
}

.login-form {
  flex: 1;
  position: relative;
  z-index: 1;
  margin: ~"min(40px, 16vh)" 30px 0;
  padding: 40px 30px;
  background: #FFFFFF;
  border-radius: 30px;
  box-shadow: 0 -4px 25px rgba(37, 71, 241, 0.15), 0 10px 30px rgba(0, 0, 0, 0.04);

  .phone-input,
  .code-input {
    background: #FFFFFF;
    box-shadow: 0px 8px 30px 0px rgba(0, 0, 0, 0.08);
    border-radius: 20px;
  }

  .code-input-warp {
    flex: 1;
    padding-right: 30px;
  }

  .get-code-btn {
    min-width: 220px;
    background: #FFFFFF;
    border-radius: 20px;
    border: 1px solid #2547F1;
    font-size: 32px;
    color: #2547F1;
    line-height: 37px;
    padding: 24px;
    box-sizing: border-box;
    text-align: center;

    &.disabled {
      border: 1px solid var(--text-color-gray);
      color: var(--text-color-gray);
      border-color: #f5f5f6;
      background-color: #f5f5f6;
    }
  }

  .input-text {
    padding: 26px 30px 26px 70px;
    font-size: 32px;
    line-height: 36px;
    text-align: left;
    font-weight: 500;
    box-sizing: border-box;
  }

  .phone-number {
    background: url('../../assets/img/login/phone.png') 30px center no-repeat;
    background-size: 32px 32px;
    width: 100%;
    box-sizing: border-box;
  }

  .verification-code {
    background: url('../../assets/img/login/lock.png') 30px center no-repeat;
    background-size: 32px 32px;
    width: 100%;
  }

  .error-message {
    color: #ee0a24;
    font-size: 24px;
    margin-top: 30px;
  }

  .code-message {
    font-size: 24px;
    margin-top: 30px;
  }
}

.code-group {
  margin-top: 30px;
}

.agreement {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  margin-top: 60px;
  font-size: 26px;
  line-height: 30px;
  color: var(--text-color-gray);

  &__radio {
    position: relative;
    flex: 0 0 auto;
    width: 36px;
    height: 36px;
    margin-top: -3px;
    border: 2px solid #cbd5e1;
    border-radius: 50%;
    box-sizing: border-box;
    background: #ffffff;

    &.checked {
      border-color: #2547F1;
      background: #2547F1;

      &::after {
        content: '';
        position: absolute;
        left: 50%;
        top: 50%;
        width: 10px;
        height: 18px;
        border: solid #ffffff;
        border-width: 0 3px 3px 0;
        transform: translate(-50%, -52%) rotate(45deg);
      }
    }
  }

  &__text {
    flex: 1;
    min-width: 0;
  }

  &__text > span {
    color: var(--link-color);
  }
}

.icon-colored {
  width: 36px;
  height: 36px;
  background-color: #1A4ED3;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  -webkit-mask-size: contain;
}

.icon-rili {
  mask-image: url('../../assets/img/rili_1.svg');
  -webkit-mask-image: url('../../assets/img/rili_1.svg');
}

.icon-dunpai {
  mask-image: url('../../assets/img/dunpai.svg');
  -webkit-mask-image: url('../../assets/img/dunpai.svg');
}

.icon-dagou {
  mask-image: url('../../assets/img/dagou_2.svg');
  -webkit-mask-image: url('../../assets/img/dagou_2.svg');
}

.feature-row {
  display: flex;
  align-items: stretch;
  width: 70%;
  margin-right: auto;
  justify-content: space-evenly;
}

.feature-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  flex: 1;
}

.feature-item:not(:last-child)::after {
  content: '';
  position: absolute;
  right: 0;
  top: 15%;
  width: 1px;
  height: 70%;
  background: rgba(255, 255, 255, 0.25);
}

.login-btn {
  margin-top: 20px;
  border-radius: 12px;

  &.disabled {
    opacity: 0.3;
  }
}

.customer-service-link {
  margin-top: 30px;
  font-size: 28px;
  color: var(--primary-color);
  line-height: 34px;
  text-align: center;
  text-decoration: underline;
}

.register-tips {
  margin-top: 60px;
  font-size: 26px;
  color: var(--text-color-gray);
  line-height: 42px;
  text-align: center;
  font-style: normal;
}

.bottom-am {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: ~"min(400px, 35vh)";
  background: url('../../assets/img/login/buttom_am.png') center bottom / 100% auto no-repeat;
  pointer-events: none;
}

::v-deep .customer-service-dialog {
  border-radius: 20px;
  overflow: hidden;
}

.customer-service {
  background: #FFFFFF;
  position: relative;
  display: flex;
  flex-direction: column;

  &__close {
    position: absolute;
    right: 18px;
    top: 24px;
    width: 56px;
    height: 56px;
    z-index: 1;

    img {
      margin: 12px auto;
      display: block;
      width: 32px;
      height: 32px;
    }
  }

  &__title {
    font-size: 42px;
    color: var(--text-color-black);
    line-height: 48px;
    font-weight: 600;
    padding: 50px 72px 20px 30px;
  }

  &__content {
    flex: 1;
    padding: 28px 30px 0;
  }

  &__row {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 150px;
    padding: 20px;
    background: #F8FAFE;
    border-radius: var(--border-radius-base);
    font-size: 28px;
    line-height: 40px;

    span {
      color: var(--primary-color);
      margin-right: 16px;
      flex-shrink: 0;
    }

    strong {
      font-size: 32px;
      color: var(--text-color-black);
      font-weight: 500;
    }
  }

  &__footer {
    padding: 30px;
    background: #FFFFFF;
  }

  &__copy {
    height: 80px;
    border-radius: 12px;
    font-size: 32px;
    line-height: 80px;
  }
}

</style>
